import API from "../../../app/api";
export const getCollections = async () => {

    const res = await API.get(`/collections`);

    if (!res.data?.success) {
        throw new Error(res.data?.message || "Failed to fetch Collections");
    }

    return res;
};
